/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Ask_User_Other_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Type your answer" |
*
* @param {Chat_Ask_User_Other_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_ask_user_other_placeholder = /** @type {((inputs?: Chat_Ask_User_Other_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Ask_User_Other_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Antwort eingeben")
	return /** @type {LocalizedString} */ ("Type your answer")
});